import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { EventInfo } from '../webApi/DataModels'
import { map, filter } from 'lodash'

class EventInfoState {
  public eventInfos:EventInfo[]
  public eventInfoOptions:any[]
  public exportProofEventInfoOptions:any[]
}
const mutations = <MutationTree<EventInfoState>>{
  setEventInfos (state: EventInfoState, eventInfos: EventInfo[]) {
    state.eventInfos = eventInfos
    state.eventInfoOptions = eventInfos.map((eventInfo: EventInfo) => {
      var label = eventInfo.Event_Info_Name
      // remove the leading STS. / POS. etc
      if (label.length > 4 && label.split('.').length > 1) label = label.substring(4)
      return {
        value: eventInfo.Event_Info_ID,
        label: label,
        selected: false
      }
    })
    state.exportProofEventInfoOptions = state.eventInfoOptions.filter((eventInfo: any) => {
      return (eventInfo.value === 10 || eventInfo.value === 1)
    })
    window.sessionStorage.setItem('Event_Info_List', JSON.stringify(state.eventInfos))
  },
  reset (state:EventInfoState) {
    state.eventInfos = []
    state.eventInfoOptions = []
    state.exportProofEventInfoOptions = []
  }
}

const actions = <ActionTree<EventInfoState, any>>{
  reset (store: ActionContext<EventInfoState, any>):void {
    store.commit('reset')
  },
  loadEventInfos (store: ActionContext<EventInfoState, any>): Promise<any> {
    if (window.sessionStorage.getItem('Event_Info_List') != null) {
      // the list has already been stored in session
      store.commit('setEventInfos', JSON.parse(window.sessionStorage.getItem('Event_Info_List')))
      return Promise.resolve('success')
    } else {
      // the list has not been stored in session yet, load from server
      return webApi.event_info.get_Event_Infos().then(
        (response) => {
          // Store the response
          store.commit('setEventInfos', response.data)
          return Promise.resolve('success')
        }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading event infos: ' + response.data.ExceptionMessage)
        return Promise.reject(response)
      })
    }
  }
}
const getters = <GetterTree<EventInfoState, any>> {
  eventInfos: (state) => {
    return state.eventInfos
  },
  eventInfoNames (state:EventInfoState):any {
    return (eventInfoIDs:number[]) => {
      return map(filter(state.eventInfos, eventInfo => (eventInfoIDs.indexOf(eventInfo.Event_Info_ID) > -1)), 'Event_Info_Name')
    }
  }
}
export default ({
  namespaced: true,
  state: new EventInfoState(),
  mutations,
  actions,
  getters
})
